import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Loading from '../views/nav1/loading.vue'
Vue.use(VueRouter)

let routes= [
  {
    path: '/',
    // 默认路径
    // redirect: to => {
    //   return '/login'
    // }
  },{
    path:'/user/member',
    name:'',
    component:resolve => require(['../views/user/member.vue'], resolve),
  },
  {
    path:'/user/forgetpassword',
    name:'',
    component:resolve => require(['../views/user/forgetpassword.vue'], resolve),
  },
  {
    path:'/print',
    name:'',
    component:resolve => require(['../views/print.vue'], resolve),
  },
    // {
    //   path:'/login',
    //   name:'Login',
    //   component:Login
    // },
    {
      path:'/home',
      name:'home',
      component:Home,
      children:[{
        path:'/login',
        name:'login',
        component:resolve => require(['../views/Login.vue'], resolve),
      },{
        path:'/home/index',
        name:'homeindex',
        component:resolve => require(['../views/home/index.vue'], resolve),
      },{
        path:'/home/druglist',
        name:'',
        component:resolve => require(['../views/home/druglist.vue'], resolve),
      },{
        path:'/home/drugdetail',
        name:'',
        component:resolve => require(['../views/home/drugdetail.vue'], resolve),
      },{
        path:'/home/Medicalhistory',
        name:'',
        component:resolve => require(['../views/home/Medicalhistory.vue'], resolve),
      },{
        path:'/home/concats',
        name:'',
        component:resolve => require(['../views/home/concats.vue'], resolve),
      },{
        path:'/home/status',
        name:'',
        component:resolve => require(['../views/home/status.vue'], resolve),
      },{
        path:'/home/alarm',
        name:'',
        component:resolve => require(['../views/home/alarm.vue'], resolve),
      },{
        path:'/home/pharmacyinfo',
        name:'',
        component:resolve => require(['../views/home/pharmacyinfo.vue'], resolve),
      },{
        path:'/user/mine',
        name:'',
        component:resolve => require(['../views/user/mine.vue'], resolve),
      },{
        path:'/user/report',
        name:'',
        component:resolve => require(['../views/user/report.vue'], resolve),
      }]
      
    },
    // {
    //   path:'/loading',
    //   component: Loading
    // }
  ]

export default routes;


// WEBPACK FOOTER //
// ./src/router/index.js